import { PopupDescription } from './util';

export const TOGGLE_POPUP = 'TOGGLE_POPUP';

export interface TogglePopupAction extends PopupDescription {
  type: typeof TOGGLE_POPUP;
}

export type PopupAction = TogglePopupAction;
